import { formatCategoryName } from '../../../../ui/formatCategoryName';

/**
 * Der Viewer blättert durch das ganze Deck: alle sichtbaren Gruppen als eine Liste in
 * Raster-Reihenfolge. Die Positionszeile bleibt kategorie-bezogen — sie sagt, wo man
 * innerhalb der aktuellen Kategorie steht, und wechselt beim Übertritt mit.
 */
export function buildViewerList(visibleGroups = []) {
  const cards = [];
  const meta = [];
  for (const group of visibleGroups) {
    const list = group.cards || [];
    list.forEach((card, i) => {
      cards.push(card);
      meta.push({ groupName: group.name, positionInGroup: i + 1, groupSize: list.length });
    });
  }
  return {
    cards,
    labelFor: (index) => {
      const m = meta[index];
      if (!m) return '';
      return `${formatCategoryName(m.groupName)} · ${m.positionInGroup} von ${m.groupSize}`;
    },
    indexOf: (groupName, indexInGroup) => {
      const treffer = meta.findIndex(
        (m) => m.groupName === groupName && m.positionInGroup === (indexInGroup ?? 0) + 1
      );
      return treffer >= 0 ? treffer : 0;
    },
  };
}
